export default {
    path: '/drive',
    name: 'drive',
    component: () => import('@/views/admin/layout.vue')
}
